// Central asset URLs for Probate Solution OC brand assets
// Original.webp = logo with white bg; Original on Transparent.webp = transparent bg
export const LOGO_URL = "/media/images/logo-mark.png";

export const HERO_HOME_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/no1bv4vk_Cover%20Photo1.webp";

// Mary Nguyen photos
export const MARY_HEADSHOT_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/il84fwed_ChatGPT%20Image%20Aug%2024%2C%202026%2C%2002_51_51%20PM.png";

export const MARY_OFFICE_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/508538v9_file_00000000d77c71fd8094927f6340bb64.png";

export const MARY_KITCHEN_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/isypy6sj_MARY%20N%20ASPER%20A7R00046%20V1.webp";

// Elegant Mary photo in kitchen with pendant lights (velvet blazer)
export const MARY_KITCHEN_WINE_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/b1mi27yx_MARY%20N%20ASPER%20A7R00062%20V3.webp";

// Mary with real client — outdoor happy shot (blonde woman)
export const HAPPY_CLIENT_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/86zegjjx_Happy%20Client.png";

// Homebot QR code — generated dynamically for demo; swap the data URL with real Homebot link on go-live
export const HOMEBOT_QR_URL =
  "https://api.qrserver.com/v1/create-qr-code/?size=280x280&margin=1&data=" +
  encodeURIComponent("https://probatesolutionoc.com/home-value?src=homebot");

// Videos
export const VIDEO_1_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/1hhnxh6g_Compress%20Version%20%20%281%29.mp4";

export const VIDEO_2_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/jw92fw3e_Compress%20Version%20%20%282%29.mp4";

// Team group shot (standing)
export const TEAM_GROUP_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/f6d6zlui_My%20team.png";

// Team gathering (conference table)
export const TEAM_GATHERING_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/t6bw9iqe_My%20team%202.png";

// Realty ONE Group West brand logo (round ONE mark)
export const ROG_WEST_LOGO_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/19m25l3p_ChatGPT%20Image%20Aug%2024%2C%202026%2C%2002_48_55%20PM.png";

// Realty ONE Group West full/rectangular wordmark
export const ROG_WEST_WORDMARK_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/3o5e3xfu_West%20Logo2.jpg";

// Provided junk removal photo (movers loading couch onto truck)
export const JUNK_REMOVAL_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/t1wsn19h_ChatGPT%20Image%20Aug%2024%2C%202026%2C%2002_51_03%20PM.png";

// Featured inherited home photo (provided by client)
export const INHERITED_HOME_URL = "/media/images/inherited-home.jpg";

// Homepage intro videos (provided by client)
export const HOMEPAGE_INTRO_VIDEOS = [
  {
    src: "/media/videos/introduction.mp4",
    title: "Meet Mary Nguyen",
    tag: "Introduction",
  },
  {
    src: "/media/videos/what-is-probate.mp4",
    title: "What Is Probate?",
    tag: "The Basics",
  },
  {
    src: "/media/videos/what-is-pcma.mp4",
    title: "What Is a PCMA?",
    tag: "Probate CMA",
  },
];

// CPRES certification seal
export const CPRES_BADGE_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/dprhvont_CPRES.png";

// Real team headshots
export const MICHAEL_OTTO_HEADSHOT_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/6l127tc5_Loan%20Officer%20Micheal%20Otto%20Pic%20-%20Copy.webp";

export const JANNETTE_LOMELI_HEADSHOT_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/bjtjsiut_Lomeli.webp";

export const LORENA_HEADSHOT_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/x12xs8si_Escrow%20Officer%20Lorena%20Headshot.jpg";

export const DAVID_HEADSHOT_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/yjq5og1r_Title%20Officer%20David%20Glanzrock.jpeg";

export const KIM_HEADSHOT_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/hiokat94_IMG_9551.JPG";

// Real client couple photo
export const CLIENTS_COUPLE_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/0kttvunx_Clients.png";

// Team roster from the "Who We Are" document
export const TEAM = [
  {
    name: "Mary Nguyen",
    role: "Founder · REALTOR · DRE #02059715",
    org: "Probate Solution OC",
    img: MARY_HEADSHOT_URL,
    phone: "(714) 391-3645",
    email: "hello@probatesolutionoc.com",
    bio: "I'm Mary Nguyen, a licensed real estate professional and the founder of Probate Solution OC and MaryCARealEstate. I got into real estate because I genuinely enjoy helping people build wealth and navigate one of the biggest decisions of their lives. My background as a biologist and data scientist shaped the analytical precision I bring to every transaction, while years running a successful ice cream and dessert shop taught me the business instincts that come from serving customers directly, every day. I specialize in residential real estate — single-family homes, multi-family units, condos, and townhomes — and provide strategic guidance through pre-foreclosure situations. As a Probate and Trust Administration Real Estate Specialist, I focus on bringing compassionate, knowledgeable support to families during probate sales. I'm a member of the National Association of Realtors, California Association of Realtors, Orange County Board of Realtors, Southern California Multiple Listing Service, and the OC Elite Group. Community matters deeply to me — I've volunteered with the American Red Cross, supported the Association of Pre-Health Professionals, given my time at the Las Vegas Homeless Shelter, and taught through the No Child Left Behind program.",
  },
  {
    name: "Lorena Veintimilla",
    role: "Branch Manager & Escrow Officer · Irvine",
    org: "Escrow Options Group · Fluent in Spanish",
    img: "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/x12xs8si_Escrow%20Officer%20Lorena%20Headshot.jpg",
    phone: "949.783.2430",
    email: "lorena.veintimilla@escrowoptions.com",
    bio: "With a distinguished career spanning nearly four decades, Lorena Veintimilla is a highly respected Escrow Officer and Office Manager known for her expertise, leadership, and unwavering commitment to excellence. Since beginning her career in 1985, she has built a strong reputation across diverse real estate markets, including North Orange County, Beverly Hills, East Los Angeles County, and Irvine. Lorena brings extensive experience in handling a wide range of transactions, from traditional sales and refinances to more complex escrows such as short sales and probates. Her deep industry knowledge and ability to navigate shifting market conditions make her a trusted resource for agents, buyers, and sellers alike. Fluent in Spanish, Lorena is able to effectively communicate with and support a diverse clientele, ensuring every party feels informed and confident throughout the escrow process. Known for her professionalism, attention to detail, and consistent results, she continues to be a go-to expert in the escrow industry.",
  },
  {
    name: "Michael Otto",
    role: "Mortgage Lending Specialist · NMLS ID #740162",
    org: "36+ years in mortgage lending",
    img: "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/6l127tc5_Loan%20Officer%20Micheal%20Otto%20Pic%20-%20Copy.webp",
    phone: "714.310.9533",
    email: "m.otto@epiqlending.com",
    bio: "With more than 36 years of experience, Michael is THE authority on mortgage lending. He sees things that other industry professionals may overlook, allowing him to have helped thousands of homeowners purchase and refinance their homes over the years. Michael is passionate about finding creative financing solutions for his clients, no matter how complex. He utilizes his dedication to learning, along with his experience and unparalleled insight to better understand the forces that drive interest rates. By staying up-to-date on the latest complexities of mortgage lending, technology and cutting edge marketing techniques for real estate, Michael has become a vital resource for homeowners and Realtors alike.",
  },
  {
    name: "Jannette Lomeli",
    role: "Compliance Director",
    org: "Realty ONE Group West · DRE #02064175",
    img: "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/bjtjsiut_Lomeli.webp",
    phone: null,
    email: "BrokerServices@ROGWest.com",
    bio: "Jannette leads our Compliance department, ensuring every transaction we handle meets the highest standard of legal and ethical compliance. Our office is backed by an on-site Compliance Officer and a Risk Management department available seven days a week — an extra layer of accountability that protects every family we serve.",
  },
  {
    name: "David Glanzrock",
    role: "Title Officer · Vice President",
    org: "WFG National Title",
    img: "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/yjq5og1r_Title%20Officer%20David%20Glanzrock.jpeg",
    phone: "714-917-9874",
    email: null,
    bio: "David brings deep title-industry expertise to our team, helping ensure every probate and trust transaction has clear, properly resolved title before closing. His attention to detail and problem-solving on complex heirship and chain-of-title issues protects families from surprises at the settlement table.",
  },
  {
    name: "Kathey Rowlands",
    role: "Transaction Coordinator · DRE #01377456",
    org: "22 years in real estate · Huntington Beach",
    img: "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/hiokat94_IMG_9551.JPG",
    phone: null,
    email: null,
    bio: "Born and raised in Southern California, Kathey has proudly called Huntington Beach home for the past 25 years. Real estate has been a meaningful part of her life for more than 22 years, and she truly enjoys helping transactions come together smoothly behind the scenes. Kathey began her career as an assistant to a top-producing real estate team and eventually found her passion in transaction coordination, supporting agents and their clients throughout the home buying and selling process. Her 24 years of experience as an office manager have given her the skills to manage the many moving parts of a transaction with efficiency and care. Kathey understands that buying or selling a home is much more than a business transaction — it's often an emotional and important life event. Her goal is to make the process as smooth and stress-free as possible while maintaining the highest level of professionalism, privacy, and confidentiality.",
  },
];

// 8-point pledge from the presentation
export const PLEDGE = [
  { n: "01", t: "Integrity", d: "Honest, transparent dealings and straightforward advice." },
  { n: "02", t: "Personalization", d: "Tailored strategies to meet your unique needs and goals." },
  { n: "03", t: "Expertise", d: "Leveraging market knowledge to guide you effectively." },
  { n: "04", t: "Communication", d: "Consistent updates and availability for your questions and concerns." },
  { n: "05", t: "Marketing", d: "Innovative techniques to showcase your property." },
  { n: "06", t: "Negotiation", d: "Assertive representation to secure the best terms and price." },
  { n: "07", t: "Dedication", d: "Unwavering commitment to achieving your real estate goals." },
  { n: "08", t: "Respect", d: "Professionalism and confidentiality in all transactions." },
];

// "When you work with us, you can expect to..." — from Who We Are + How We Market docs
export const CLIENT_EXPECTATIONS = [
  "Realize the highest possible return on the sale of your home",
  "Reduce time on market through strategic pricing and exposure",
  "Understand every term, process, and document involved in your sale",
  "Reach more qualified buyers and agents through broad market exposure",
  "Receive regular market updates to support informed decisions",
  "Have a skilled negotiator working on your behalf",
  "Gain peace of mind, knowing every detail is handled by licensed professionals",
  "Give love and compassion. It's free.",
];

export const WHY_CHOOSE = [
  "We're certified probate specialists — not generalists learning as they go.",
  "We operate with compliance officers and risk managers behind every transaction.",
  "We represent every client with integrity and honesty, first and always.",
  "Our reach is national and international.",
  "Our principles are simple: integrity, honesty, and compassion.",
  "We market every home using the most current real estate technology available.",
];

// ---- Orange County coastal lifestyle assets ----
// Client-provided luxury coastal home tour video (silent)
export const OC_LIFESTYLE_VIDEO_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/c0j2uz1h_yWLTRBfH2nXxNk2y1Sx8b4Ze10hNYMlUOAmGdZKA.mp4";
// Client-provided real OC listing photos
export const OC_HARBOR_HOME_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/v9m0inhr_image.png";
export const OC_SUNSET_RANCH_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_probate-luxury-demo/artifacts/swsds3r3_image.png";
// Complementary OC coastal stock
export const OC_NEIGHBORHOOD_AERIAL_URL =
  "https://images.unsplash.com/photo-1602110604609-b40d3dff23c2?w=1600&q=80";
export const OC_PIER_SUNSET_URL =
  "https://images.unsplash.com/photo-1646822084909-d1b9d54331f0?w=1600&q=80";
export const OC_PALMS_SUNSET_URL =
  "https://images.unsplash.com/photo-1581609836630-9007630f7a7b?w=1600&q=80";
export const OC_COASTAL_BUILDING_URL =
  "https://images.unsplash.com/photo-1760773766930-2e4efd47f496?w=1600&q=80";
export const OC_BEACH_CALM_URL =
  "https://images.unsplash.com/photo-1634930949331-36ec95d482fc?w=1600&q=80";

// ---- Sep 2026 client photo replacements (hosted locally in /public/media) ----
export const INHERITED_CARD_HOME_URL = "/media/images/inherited-card-home.jpg";
export const OC_STONE_HOME_URL = "/media/images/oc-stone-home.jpg";
export const HEART_AIRSHOW_URL = "/media/images/heart-airshow.jpg";
export const OC_OCEAN_VIDEO_URL = "/media/videos/were-here-ocean.mp4";
// Clean golden-hour coastal home (replaces watermarked listing photo)
export const OC_GOLDEN_HOUR_HOME_URL =
  "https://images.unsplash.com/photo-1595832880577-a84565468640?w=1200&q=80";
